import { NumberUtils } from '@modeso/aumico-lib-core-fe';
import { IAccount } from '@modeso/types__aumico-lib-annualreport-be';
import { cloneDeep } from 'lodash-es';

export class AccountsHelper {
    public static roundAccountsValues(accounts: IAccount[]): IAccount[] {
        const roundedAccounts = cloneDeep<IAccount[]>(accounts);
        roundedAccounts.forEach((account) => {
            let closingAdjustment: number | undefined;
            if (account.closingAdjustment != null && NumberUtils.isFinite(account.closingAdjustment)) {
                closingAdjustment = NumberUtils.roundNumber(account.closingAdjustment);
            }

            let openingAdjustment: number | undefined;
            if (account.openingAdjustment != null && NumberUtils.isFinite(account.openingAdjustment)) {
                openingAdjustment = NumberUtils.roundNumber(account.openingAdjustment);
            }

            let closingReClass: number | undefined;
            if (account.closingReClass != null && NumberUtils.isFinite(account.closingReClass)) {
                closingReClass = NumberUtils.roundNumber(account.closingReClass);
            }

            let openingReClass: number | undefined;
            if (account.openingReClass != null && NumberUtils.isFinite(account.openingReClass)) {
                openingReClass = NumberUtils.roundNumber(account.openingReClass);
            }

            let calculatedClosingBalance: number | undefined;
            if (account.calculatedClosingBalance != null && NumberUtils.isFinite(account.calculatedClosingBalance)) {
                calculatedClosingBalance = NumberUtils.roundNumber(account.calculatedClosingBalance);
            }

            let calculatedOpeningBalance: number | undefined;
            if (account.calculatedOpeningBalance != null && NumberUtils.isFinite(account.calculatedOpeningBalance)) {
                calculatedOpeningBalance = NumberUtils.roundNumber(account.calculatedOpeningBalance);
            }
            if (account.closingBalance != null && NumberUtils.isFinite(account.closingBalance)) {
                account.closingBalance = NumberUtils.roundNumber(account.closingBalance);
            }
            if (account.openingBalance != null && NumberUtils.isFinite(account.openingBalance)) {
                account.openingBalance = NumberUtils.roundNumber(account.openingBalance);
            }

            account.calculatedClosingBalance = calculatedClosingBalance;

            account.calculatedOpeningBalance = calculatedOpeningBalance;

            account.closingAdjustment = closingAdjustment;

            account.openingAdjustment = openingAdjustment;

            account.closingReClass = closingReClass;

            account.openingReClass = openingReClass;
        });

        return roundedAccounts;
    }
}
